import { classNames } from 'primereact/utils';
import React from 'react';
import img from '../../assets/dndIcon.png.js';
import { useAppSelector } from '../../hooks/hooks.js';
import { selectMode } from '../../store/reducers/enginePropertiesSlice.js';

const C2RootContainer = (props) => {
    const mode = useAppSelector(selectMode);
    const classes = classNames({
        "w-full": true,
        "h-full": true,
        "p-5": true,
        "flex": true,
        "flex-column": true,
        "gap-2": true,
        "bg-white-50": true,
        "align-items-baseline": true,
        "root-container": true
    });
    const showDndHint = mode === "design" &&
        typeof props.children !== undefined &&
        React.Children.count(props.children) === 0;
    if (showDndHint) {
        return (React.createElement("div", { className: "w-full h-full flex gap-2 bg-white-50 align-items-center justify-content-center empty-helper", style: { height: '100vh !important' } },
            React.createElement("div", { className: "w-4 border-round-2xl border-dashed border-indigo-300 bg-indigo-50 flex flex-column align-items-center" },
                React.createElement("img", { src: img, height: "64px", width: "64px", className: "mt-5 mb-3" }),
                React.createElement("div", { className: "w-10 mb-3 text-center text-lg text-white-700 font-medium line-height-3" }, "Pick components from the menu on the left and drag & drop them into the screen"))));
    }
    return (React.createElement("div", { className: classes }, props.children));
};

export { C2RootContainer as default };
//# sourceMappingURL=C2RootContainer.js.map
